<template>
    <div class="mb-8 md:mb-10">
        <h2 class="section-title">{{ title }}</h2>
        <p v-if="$slots.default" class="mt-3 max-w-2xl prose-body text-muted">
            <slot />
        </p>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true }
    }
};
</script>
